import { render, staticRenderFns } from "./StemdoersManagerPage.vue?vue&type=template&id=c98f6832"
import script from "./StemdoersManagerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StemdoersManagerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c98f6832')) {
      api.createRecord('c98f6832', component.options)
    } else {
      api.reload('c98f6832', component.options)
    }
    module.hot.accept("./StemdoersManagerPage.vue?vue&type=template&id=c98f6832", function () {
      api.rerender('c98f6832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/manager/stemdoers/StemdoersManagerPage.vue"
export default component.exports